/*
 * Site: {SITE}
 * File: custom/accordion
 * ============================================================================
 * Some description...
 * ============================================================================
 * Built by Xanthe Studios | xanthestudios.co.uk
 * ============================================================================
 */

$('.js-summary').click(function() {

	if ($(this).hasClass('is-selected')) {

		// Some description...
		$(this).removeClass('is-selected');

		// Some description...
		$('[data-panel=' + $(this).data('summary') + ']').slideUp(300);

	} else {

		// Some description...
		$('.c-accordion__summary').removeClass('is-selected');

		// Some description...
		$('.c-accordion__panel').slideUp(300);

		// Some description...
		$(this).addClass('is-selected');

		// Some description...
		$('[data-panel=' + $(this).data('summary') + ']').slideDown(300);

	}

});
